<template>
  <CustomerDetailPlaceholderTab title="Estado de Cuenta" />
</template>

<script>
import CustomerDetailPlaceholderTab from '@/components/customers/detail/tabs/CustomerDetailPlaceholderTab.vue';

export default {
  name: 'CustomerDetailAccountStatementTab',
  components: {
    CustomerDetailPlaceholderTab,
  },
};
</script>
